export default [
  { id: 1, name: 'Москва Спортивная' },
  { id: 2, name: 'Москва ЦО' },
  { id: 3, name: 'Воронеж ЦО' },
  { id: 4, name: 'Челябинск' },
  { id: 5, name: 'СПб.ЦКК' },
  { id: 6, name: 'Москва NFP' },
  { id: 7, name: 'Москва Марксистская' },
  { id: 8, name: 'Москва ШЭ' },
  { id: 9, name: 'Москва Войковская' },
  { id: 10, name: 'Ростов-на-Дону' },
  { id: 11, name: 'СПб.Ломоносовская' },
  { id: 12, name: 'Москва Белорусская' },
  { id: 13, name: 'Красноярск' },
  { id: 14, name: 'Москва Павелецкая' },
  { id: 15, name: 'Краснодар ЦО' },
  { id: 16, name: 'Москва Калужская' },
  { id: 17, name: 'Москва ЭР' },
  { id: 18, name: 'Dubai Main Office' },
  { id: 19, name: 'Екатеринбург ПЦ' },
  { id: 20, name: 'НН пл. Минина' },
  { id: 21, name: 'Москва Преображенка' },
  { id: 22, name: 'Самара' },
  { id: 23, name: 'Краснодар на Кожевенной' },
  { id: 24, name: 'Новосибирск Маяковский' },
  { id: 25, name: 'СПб.А. Невского' },
  { id: 26, name: 'НН пл. Революции' },
  { id: 27, name: 'Москва ЛАЙВ Технологии' },
  { id: 28, name: 'Казань' },
  { id: 29, name: 'Москва Савёловская' },
  { id: 30, name: 'Тюмень' },
  { id: 31, name: 'Томск' },
  { id: 32, name: 'Саратов' },
  { id: 33, name: 'Красноярск ПЦ' },
  { id: 34, name: 'Иркутск на Российской' },
  { id: 35, name: 'СПб.Ушаковская' },
  { id: 36, name: 'СПб.Горьковская' },
  { id: 37, name: 'Москва Управление данными' },
  { id: 38, name: 'Тамбов' },
  { id: 39, name: 'СПб.Электронные системы' },
  { id: 40, name: 'Москва Коломенская' },
  { id: 41, name: 'Москва Центр бюджетного учета' },
  { id: 42, name: 'Астана' },
  { id: 43, name: 'СПб.Приморская' },
  { id: 44, name: 'Хабаровск' },
  { id: 45, name: 'Новосибирск Гагаринская' },
  { id: 46, name: 'Омск' },
  { id: 47, name: 'Алматы Мега' },
  { id: 48, name: 'Пенза' },
  { id: 49, name: 'СПб.Черная речка' },
  { id: 50, name: 'Одесса' },
  { id: 51, name: 'TechnoPeak Dubai Office' },
  { id: 52, name: 'Екатеринбург Центральный' },
  { id: 53, name: 'Калининград' },
  { id: 54, name: 'Алматы АДК' },
  { id: 55, name: 'БИТ:Смарт' },
  { id: 56, name: 'СПб.Московская' },
  { id: 57, name: 'Москва Таганская' },
  { id: 58, name: 'Брест' },
  { id: 59, name: 'Уфа' },
  { id: 60, name: 'Костанай' },
  { id: 61, name: 'Ташкент' },
  { id: 62, name: 'Новороссийск' },
  { id: 63, name: 'Москва БИТ.Wi-Fi+AutoID' },
  { id: 64, name: '1С.Подмосковье' },
  { id: 65, name: 'Волгоград' },
  { id: 66, name: 'Ижевск' },
  { id: 67, name: 'СПб.Интернет-проекты' },
  { id: 68, name: 'Кемерово' },
  { id: 69, name: 'СПб.УЦ' },
  { id: 70, name: 'Оренбург' },
  { id: 71, name: 'Ярославль' },
  { id: 72, name: 'Иркутск Проектный офис' },
  { id: 73, name: 'Владивосток' },
  { id: 74, name: 'Владимир' },
  { id: 75, name: 'Пермь' },
  { id: 76, name: 'Лесосибирск' },
  { id: 77, name: 'Канск' },
  { id: 78, name: 'Бишкек' },
  { id: 79, name: 'Москва Автоматизация электронных торгов и тендеров' },
  { id: 80, name: 'Техническая команда' },
];
